import React from 'react';
import { FaPhone } from 'react-icons/fa';

const BuyerLedgerContactDetails = ({ form, errors, onChange }) => (
  <div className="card border-0 shadow-sm mb-4 blc-card blc-card-red">
    <div className="card-header bg-white border-0 pb-0">
      <h5 className="mb-0 blc-card-title blc-card-title-red">
        <FaPhone className="me-2" />
        Contact Details
      </h5>
    </div>
    <div className="card-body">
      <div className="row">
        <div className="col-lg-6 mb-3">
          <label className="form-label fw-semibold text-dark">
            Address <span className="text-danger">*</span>
          </label>
          <textarea
            name="contactAddress"
            value={form.contactAddress}
            onChange={onChange}
            className={`form-control blc-input ${errors.contactAddress ? 'is-invalid' : ''}`}
            rows="3"
            placeholder="Enter contact address"
          />
          {errors.contactAddress && <div className="invalid-feedback d-block">{errors.contactAddress}</div>}
        </div>
        <div className="col-lg-6 mb-3">
          <label className="form-label fw-semibold text-dark">Commercial Contact</label>
          <input
            name="contactCommercial"
            value={form.contactCommercial}
            onChange={onChange}
            className="form-control form-control-lg blc-input"
            placeholder="Enter commercial contact"
          />
        </div>
        <div className="col-lg-6 mb-3">
          <label className="form-label fw-semibold text-dark">
            Billing Contact <span className="text-danger">*</span>
          </label>
          <input
            name="billingContact"
            value={form.billingContact}
            onChange={onChange}
            className={`form-control form-control-lg blc-input ${errors.billingContact ? 'is-invalid' : ''}`}
            placeholder="Enter billing contact"
          />
          {errors.billingContact && <div className="invalid-feedback d-block">{errors.billingContact}</div>}
        </div>
        <div className="col-lg-6 mb-3">
          <label className="form-label fw-semibold text-dark">
            Email <span className="text-danger">*</span>
          </label>
          <input
            name="email"
            value={form.email}
            onChange={onChange}
            className={`form-control form-control-lg blc-input ${errors.email ? 'is-invalid' : ''}`}
            placeholder="email@example.com"
          />
          {errors.email && <div className="invalid-feedback d-block">{errors.email}</div>}
        </div>
      </div>
    </div>
  </div>
);

export default BuyerLedgerContactDetails;
